export default "__VITE_ASSET__10f9f8b5__"